import { isBrowser } from '~/utils';
import { useEffect } from 'react';

export const usePreventBodyScroll = ({ enable }: { enable: boolean }) => {
  useEffect(() => {
    if (!enable || !isBrowser()) return;

    // Prevent layout shift from scrollbar removal
    document.body.style.overflowY = 'hidden';

    return () => {
      document.body.style.overflowY = 'unset';
    };
  }, [enable]);
};
